import { configConstants as ths } from "../../../constants/configs";

const initialState = {
  loading: true,
  list: [],
  theme: null,
  ues: [],
  ue: null,
  ecs: [],
  ec: null,
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ths.GET_THEMES:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case ths.GET_THEME:
      return {
        ...state,
        loading: false,
        theme: payload,
      };
    case ths.GET_UES:
      return {
        ...state,
        loading: false,
        ues: payload,
      };
    case ths.GET_UE:
      return {
        ...state,
        loading: false,
        ue: payload,
      };
    case ths.GET_ECS:
      return {
        ...state,
        loading: false,
        ecs: payload,
      };
    case ths.GET_EC:
      return {
        ...state,
        loading: false,
        ec: payload,
      };
    default:
      return state;
  }
}
